import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogridhneshwarcab() {



    const cardData = {





keyword: "Mumbai to Grishneshwar Cab",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Mumbai to Grishneshwar Cab Service for devotees, families, and travelers planning a spiritual journey to one of Maharashtra's most important Jyotirlinga destinations. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, and premium cab options for a safe and peaceful travel experience. With experienced drivers, well-maintained vehicles, transparent pricing, doorstep pickup from Mumbai, flexible booking options, and 24/7 customer support, we ensure a smooth pilgrimage journey. Whether you need a one-way cab, round trip taxi, Jyotirlinga tour package, or Maharashtra temple tour, Shreesha Tours & Travels provides dependable transportation with complete comfort and convenience.",

topPlaces: [
  {
    title: "Grishneshwar Jyotirlinga Temple",
    description: "Grishneshwar Temple near Ellora is one of the twelve Jyotirlingas of Lord Shiva and a major pilgrimage destination in Maharashtra. Devotees visit this sacred temple throughout the year for spiritual darshan."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves is a UNESCO World Heritage Site famous for ancient Buddhist, Hindu, and Jain rock-cut caves. It is one of India's most remarkable historical and architectural attractions."
  },
  {
    title: "Bibi Ka Maqbara Aurangabad",
    description: "Bibi Ka Maqbara is a famous historical monument known for its Mughal architecture and beautiful design. It is one of the most visited attractions in Aurangabad."
  },
  {
    title: "Daulatabad Fort",
    description: "Daulatabad Fort is a historic hill fort famous for its strong architecture, ancient gateways, and strategic importance. It is a popular destination for history enthusiasts."
  },
  {
    title: "Ajanta Caves",
    description: "Ajanta Caves is a UNESCO World Heritage Site known for ancient Buddhist paintings, sculptures, and remarkable rock-cut architecture. It is a must-visit destination for heritage lovers."
  },
  {
    title: "Panchakki Aurangabad",
    description: "Panchakki is a historic water mill and architectural attraction in Aurangabad known for its engineering design and peaceful surroundings."
  },
  {
    title: "Shirdi Sai Baba Temple",
    description: "Shirdi is one of Maharashtra's most popular pilgrimage destinations, famous for Sai Baba Temple, Dwarkamai, and spiritual attractions. Many devotees combine Grishneshwar and Shirdi trips."
  },
  {
    title: "Trimbakeshwar Jyotirlinga",
    description: "Trimbakeshwar near Nashik is one of the twelve Jyotirlingas and an important religious destination. It is frequently included in Maharashtra Jyotirlinga cab tours."
  },
  {
    title: "Bhimashankar Jyotirlinga",
    description: "Bhimashankar is one of the twelve Jyotirlingas surrounded by Sahyadri forests and natural beauty. It is a popular destination for devotees and nature lovers."
  },
  {
    title: "Shani Shingnapur Temple",
    description: "Shani Shingnapur is a famous pilgrimage village dedicated to Lord Shani. Devotees often combine this spiritual destination with Grishneshwar and other Maharashtra temple tours."
  }
],




"services": [
  {
    "name": "Mumbai to Grishneshwar Cab",
    "description": "Book Mumbai to Grishneshwar Cab for a safe, comfortable, and reliable religious journey with professional chauffeurs and well-maintained AC vehicles. Enjoy a peaceful trip to Grishneshwar Jyotirlinga Temple with Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options suitable for family darshan and spiritual tours."
  },
  {
    "name": "Mumbai to Grishneshwar Taxi",
    "description": "Choose Mumbai to Grishneshwar Taxi for convenient and affordable temple travel with experienced drivers and comfortable vehicles. Get doorstep pickup, clean AC cars, transparent pricing, and reliable taxi service for devotees visiting Grishneshwar Jyotirlinga."
  },
  {
    "name": "Mumbai to Grishneshwar Cab Service",
    "description": "Book Mumbai to Grishneshwar Cab Service for hassle-free pilgrimage transportation with trained chauffeurs and premium vehicles. Our cab services are ideal for religious trips, family journeys, weekend tours, and spiritual travel with flexible booking options."
  },
  {
    "name": "Mumbai to Grishneshwar Temple Cab",
    "description": "Reserve Mumbai to Grishneshwar Temple Cab for comfortable transportation to the famous Grishneshwar Jyotirlinga Temple near Ellora. Enjoy reliable pickup, experienced drivers, spacious vehicles, and a smooth temple visit experience."
  },
  {
    "name": "Mumbai to Grishneshwar Darshan Cab",
    "description": "Book Mumbai to Grishneshwar Darshan Cab for a convenient pilgrimage experience with dedicated vehicles and professional chauffeurs. Perfect for family darshan, religious groups, and travelers looking for comfortable temple travel."
  },
  {
    "name": "Mumbai to Grishneshwar Jyotirlinga Cab",
    "description": "Choose Mumbai to Grishneshwar Jyotirlinga Cab for a peaceful spiritual journey to one of the twelve Jyotirlingas. Enjoy premium vehicles, skilled drivers, and flexible travel plans for devotees and families."
  },
  {
    "name": "Mumbai to Grishneshwar Tour Package",
    "description": "Book Mumbai to Grishneshwar Tour Package by cab for a complete religious travel experience. Enjoy comfortable transportation, flexible schedules, and customized cab packages for temple visits and nearby sightseeing destinations."
  },
  {
    "name": "Mumbai to Grishneshwar Taxi Booking",
    "description": "Complete Mumbai to Grishneshwar Taxi Booking with easy reservations and multiple vehicle choices. Select Sedan, SUV, Ertiga, Innova, or premium cars according to your group size and travel requirements."
  },
  {
    "name": "Mumbai to Grishneshwar Car Rental",
    "description": "Choose Mumbai to Grishneshwar Car Rental for chauffeur-driven vehicles designed for religious and family travel. Get spacious cars, professional drivers, flexible rental options, and comfortable journeys from Mumbai."
  },
  {
    "name": "Mumbai to Grishneshwar Innova Cab",
    "description": "Book Mumbai to Grishneshwar Innova Cab for spacious and comfortable pilgrimage travel with premium seating and extra luggage space. Ideal for families and groups planning a relaxing Jyotirlinga Darshan trip."
  },
  {
    "name": "Mumbai to Grishneshwar Ertiga Cab",
    "description": "Reserve Mumbai to Grishneshwar Ertiga Cab for affordable group transportation with comfortable interiors and smooth performance. Suitable for families and small groups visiting Grishneshwar Temple."
  },
  {
    "name": "Mumbai Religious Tour Taxi",
    "description": "Choose Mumbai Religious Tour Taxi for safe and comfortable temple journeys across Maharashtra. Travel with professional chauffeurs and reliable vehicles for Grishneshwar, Jyotirlinga Darshan, and other spiritual destinations."
  },
  {
    "name": "Best Mumbai Grishneshwar Cab Booking",
    "description": "Choose the Best Mumbai Grishneshwar Cab Booking service for safe, comfortable, and reliable pilgrimage travel. Enjoy premium vehicles, trained chauffeurs, flexible booking options, and affordable cab packages for Grishneshwar Jyotirlinga Darshan with family and devotees."
  }
],
"tableData": [
  ["Mumbai to Grishneshwar Cab", "Mumbai to Grishneshwar Taxi"],
  ["Mumbai to Grishneshwar Cab Service", "Mumbai to Grishneshwar Temple Cab"],
  ["Mumbai to Grishneshwar Darshan Cab", "Mumbai to Grishneshwar Jyotirlinga Cab"],
  ["Mumbai to Grishneshwar Tour Package", "Mumbai to Grishneshwar Taxi Booking"],
  ["Mumbai to Grishneshwar Car Rental", "Mumbai to Grishneshwar Innova Cab"],
  ["Mumbai to Grishneshwar Ertiga Cab", "Mumbai Religious Tour Taxi"],
  ["Best Mumbai Grishneshwar Cab Booking", ""]
],




whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Grishneshwar Cab Service",
    WhyChoosedescription: "Shreesha Travels provides reliable Mumbai to Grishneshwar cab services for devotees, families, and travellers visiting one of the famous Jyotirlinga temples. Enjoy a peaceful pilgrimage journey with comfortable vehicles, experienced chauffeurs, and flexible travel plans."
  },
  {
    WhyChooseheading: "Hassle-Free Spiritual Journey from Mumbai",
    WhyChoosedescription: "Plan your Mumbai to Grishneshwar temple trip with convenient private cab booking. Our services are suitable for Jyotirlinga darshan, religious tours, family pilgrimages, and customized Maharashtra temple routes."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Pilgrimage Travel",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and other vehicles based on your group size and comfort requirements."
  },
  {
    WhyChooseheading: "Ideal for Jyotirlinga & Aurangabad Tours",
    WhyChoosedescription: "Our Mumbai to Grishneshwar taxi service is perfect for devotees combining temple visits with nearby attractions like Ellora Caves, Bhadra Maruti Temple, and other historical places around Aurangabad."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Options",
    WhyChoosedescription: "Select a one-way cab for direct travel to Grishneshwar or choose a round-trip package with flexible return timing, waiting options, and customized sightseeing arrangements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Maharashtra Routes",
    WhyChoosedescription: "Our professional drivers have good knowledge of Mumbai-Aurangabad routes and pilgrimage destinations, ensuring safe travel, timely service, and a comfortable journey."
  },
  {
    WhyChooseheading: "Well-Maintained Cars for Long Distance Trips",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, air-conditioned, and inspected before departure to provide passengers with a smooth and reliable travel experience."
  },
  {
    WhyChooseheading: "Book Mumbai to Grishneshwar Cab with Shreesha Travels",
    WhyChoosedescription: "Get trusted cab assistance, transparent pricing, comfortable vehicles, and professional chauffeur services for your Mumbai to Grishneshwar Jyotirlinga journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a Mumbai to Grishneshwar cab for Jyotirlinga darshan?",
    answer: "Yes, we provide comfortable cab services from Mumbai to Grishneshwar for devotees, families, and religious tours."
  },
  {
    question: "Is Mumbai to Grishneshwar one-way cab service available?",
    answer: "Yes, one-way taxi bookings are available for passengers who need direct travel to Grishneshwar."
  },
  {
    question: "Which cars are available for Mumbai to Grishneshwar travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, and Tempo Travellers."
  },
  {
    question: "Can I visit Ellora Caves along with Grishneshwar temple?",
    answer: "Yes, customized travel plans can include Ellora Caves and other nearby sightseeing locations as per your itinerary."
  },
  {
    question: "Is this cab service comfortable for senior citizens?",
    answer: "Yes, spacious vehicles and experienced drivers make the journey comfortable and convenient for senior citizens."
  },
  {
    question: "Do you provide round-trip Mumbai to Grishneshwar taxi service?",
    answer: "Yes, round-trip cab packages are available with flexible return schedules and waiting options."
  },
  {
    question: "Can I book a cab from Mumbai Airport to Grishneshwar?",
    answer: "Yes, airport pickup and direct cab services can be arranged according to your travel requirements."
  },
  {
    question: "How is the Mumbai to Grishneshwar cab fare calculated?",
    answer: "The fare depends on vehicle type, travel distance, trip duration, waiting time, route, and selected package."
  },
  {
    question: "Are multi-day pilgrimage tours available?",
    answer: "Yes, customized multi-day temple tours and Maharashtra pilgrimage packages can be arranged."
  },
  {
    question: "How can I book Mumbai to Grishneshwar Cab with Shreesha Travels?",
    answer: "Share your travel date, pickup location, passenger details, preferred vehicle, and trip requirements to receive a customized quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Pravin Jadhav",
    feedback: "Our Mumbai to Grishneshwar pilgrimage trip was very comfortable. The driver was experienced, the car was clean, and the complete journey was managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anita More",
    feedback: "The temple visit became easy with Shreesha Travels. The comfortable vehicle and professional service made our family pilgrimage peaceful and memorable.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Grishneshwar Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-grishneshwar-cab.webp",
  "description":
    "Book Mumbai to Grishneshwar Cab with Shreesha Tours & Travels for comfortable and reliable pilgrimage taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for Grishneshwar Temple Darshan, Jyotirlinga tours, family trips, religious journeys, and outstation travel from Mumbai with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-grishneshwar-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Mumbai to Grishneshwar Cab | Temple Darshan Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Grishneshwar Cab with Shreesha Travels for safe and comfortable pilgrimage taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for Grishneshwar Temple Darshan, Jyotirlinga tours, family trips, and religious journeys with 24x7 booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Grishneshwar Cab, Mumbai to Grishneshwar Taxi, Mumbai to Grishneshwar Cab Service, Mumbai to Grishneshwar Temple Cab, Mumbai to Grishneshwar Darshan Cab, Mumbai Grishneshwar Jyotirlinga Cab, Mumbai to Grishneshwar Taxi Booking, Mumbai to Grishneshwar Car Rental, Mumbai Religious Tour Cab, Mumbai Temple Tour Taxi, Grishneshwar Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogridhneshwarcab;